import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { installKeyboardGuard } from "@/lib/keyboard";

installKeyboardGuard();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").then((reg) => { reg.update().catch(() => {}); navigator.serviceWorker.controller?.postMessage("refresh-shell"); }).catch(() => {}));
}
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
// The install-app splash (public/index.html) is hidden by App once the first screen is ready; fallback so it never sticks.
setTimeout(() => window.__hideSplash?.(), 6000);
